import firebase from "../../firebase";
import * as constants from "../../Constatnts";
import axios from "axios";
const BaseURL = "https://backend-197598313260.asia-south1.run.app";


export async function getSmartProducts(RegistrationID, from, size, searchText) {
  try {
    const searchParameters = { RegistrationID, searchText, from, size };
    const response = await axios.get(BaseURL + "/v1/smrtproducts", {
      params: searchParameters,
    });

    return response.data;
  } catch (error) {
    console.error("Error in getProductsSearch:", error);
    throw error;
  }
}

export async function getProductsByBarCodeAPI(
  RegistrationID,
  from,
  size,
  searchText,
  gidSearch = false
) {
  try {
    const searchParameters = { RegistrationID, searchText, gidSearch };
    console.log("searchParameters", searchParameters);
    const response = await axios.get(`${BaseURL}/v1/catalogsearch`, {
      params: searchParameters,
    });
    console.log("getProductsByBarCodeAPI response.data", response.data);
    return response.data;
  } catch (error) {
    //console.error("Error in getProductsSearch:", error);
    //throw error;
  }
}

export async function getProductsByIDAPI(RegistrationID, ProductID) {
  try {
    const searchParameters = { RegistrationID, ProductID };
    const response = await axios.get(
      BaseURL + "/v1/pincode/catalog/smart/" + ProductID + "/sellingprice",
      {
        params: searchParameters,
      }
    );
    return response.data;
  } catch (error) {
    //console.error("Error in getProductsSearch:", error);
    //throw error;
  }
}


export const checkIfProductAlreadyExist = (
  registrationid,
  barCode = "",
  SKU = ""
) => {
  return async (dispatch, getState) => {
    try {
      let filters = [];

      if (SKU.trim() !== "")  {
        filters.push({
          field: "SKU",
          operator: "exact",
          clause: "must",
          value: SKU.trim(),
        });
      }

       if (barCode.trim() !== "") {
        filters.push({
          field: "BarCode",
          operator: "exact",
          clause: "must",
          value: barCode.trim(),
        });
      }

      filters.push({
        field: "IsDeleted",
        operator: "exact",
        clause: "must",
        value: false,
      });

      let query = {
        filters,
        pagination: {
          from: 0,
          size: 1000,
        },
        sort: [],
        returnFields: [],
      };

      const token = getState().user.uat;

      const response = await axios.post(
        `${constants.API_URL}/catalog/products/search`,
        query,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const products = response.data.products || [];
      return products.length > 0;
    } catch (error) {
      console.error("check error:", error);
      throw error;
    }
  };
};



export async function getSamrtProducts(RegistrationID, from, size, searchText) {
  try {
    const searchParameters = { RegistrationID, searchText, from, size };
    const response = await axios.get(`${BaseURL}/v1/smrtproducts`, {
      params: searchParameters,
    });
    // console.log("response", response);
    return response.data;
  } catch (error) {
    console.error("Error in getProductsSearch:", error);
    throw error;
  }
}
